import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { CardTitle } from '@/components/ui/card';
    import { columns } from '@/tables/columns/salary-log';
    import { computed } from 'vue';
    import { Head } from '@inertiajs/vue3';
    import { usePage } from '@inertiajs/vue3';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import DataTable from '@/components/datatable/DataTable.vue';
    import PageCard from '@/components/PageCard.vue';
    import QueryKey from '@/enums/QueryKey';
    import type { SharedData, BreadcrumbItem } from '@/types';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityLog',
  setup(__props) {

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);
    const selectedCompanyName = computed(() => page.props.auth.user.selected_company_name);

    const { t } = useI18n();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'dashboards.payroll',
        },
        {
            title: 'menu.payroll_activity_log',
        },
    ];

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.SALARY_LOG, selectedCompanyId],
        queryFn: getSalaryLog,
        enabled: computed(() => !!page.props.auth.user.selected_company_id),
    });

    async function getSalaryLog() {
        const { data } = await axios.get(route('v2.salary.log.table'));
        const rows = data?.data ?? [];
        return rows
            .slice()
            .sort((a: any, b: any) => new Date(b.date).getTime() - new Date(a.date).getTime());
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _unref(t)('payrolls.activity_log.header', { company: selectedCompanyName.value })
    }, null, 8, ["title"]),
    _createVNode(AppLayout, {
      breadcrumbs: breadcrumbs,
      "require-selected-company": ""
    }, {
      default: _withCtx(() => [
        _createVNode(PageCard, null, {
          default: _withCtx(() => [
            _createVNode(DataTable, {
              "table-key": _unref(QueryKey).SALARY_LOG,
              columns: _unref(columns),
              data: _unref(data),
              loading: _unref(isPending),
              "manual-sorting": true,
              "default-sorting": [
                    {
                        id: 'date',
                        desc: true,
                    },
                ]
            }, {
              title: _withCtx(() => [
                _createVNode(_unref(CardTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('payrolls.activity_log.header', { company: selectedCompanyName.value })), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["table-key", "columns", "data", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})